<template>
  <div>
    <div class="my-4">
      <h1>午睡チェック作成</h1>
    </div>

    <div class="my-4">
      <h3>パターンから選択</h3>
      
      <div>
        <v-progress-linear
          v-if="isFetchingTemplate"
          indeterminate
          color="primary"
          class="my-8"
        ></v-progress-linear>
      </div>

      <div v-if="napTemplates.length === 0" class="my-4">
        <v-card
          variant="outlined"
          class="pa-4 d-flex align-center justify-center"
        >
          <div class="grey--text">午睡チェックのパターンが登録されていません</div>
        </v-card>
      </div>
      <div v-else class="my-4">
        <v-card
          variant="outlined"
          class="pa-3 mb-2"
          v-for="t in napTemplates"
          :key="t.napTemplateId"
        >
          <div class="d-flex align-center">
            <div class="d-flex align-center">
              <div class="mr-4"> {{ t.templateTitle }} </div>
              <div>クラス</div>
            </div>

            <v-spacer></v-spacer>

            <v-btn
              color="primary"
              class="mr-2"
              variant="flat"
              @click="selectTemplate(t)"
            >選択</v-btn>
            <v-btn
              color="red"
              class="mr-2"
              variant="outlined"
              @click="openDeleteModal(t)"
            >削除</v-btn>
          </div>
        </v-card>
      </div>
    </div>

    <v-divider class="my-4"></v-divider>

    <div class="my-4">
      <h2 class="mb-4">新規作成</h2>
      <v-row>
        <v-col cols="4">
          <h4>日付</h4>
          <v-text-field
            type="date"
            variant="outlined"
            density="compact"
            hide-details
            v-model="date"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="4">
          <h4>記録者</h4>
          <v-select
            variant="outlined"
            density="compact"
            hide-details
            :items="staffOptions"
            item-value="userId"
            item-title="name"
            v-model="recorderId"
          ></v-select>
        </v-col>
      </v-row>

      <v-row class="mb-4">
        <v-col cols="3">
          <h4>クラス選択</h4>
          <v-select
            variant="outlined"
            density="compact"
            hide-details
            multiple
            :items="classOptions"
            item-title="title"
            item-value="value"
            v-model="classIds"
          ></v-select>
          <v-progress-linear
            v-if="isFetchingClasses"
            indeterminate
            color="primary"
          ></v-progress-linear>
        </v-col>

        <v-col cols="3">
          <h4>年齢選択</h4>
          <v-select
            variant="outlined"
            density="compact"
            hide-details
            multiple
            :items="ageOptions"
            item-value="age"
            item-title="label"
            v-model="ages"
          ></v-select>
        </v-col>

        <v-col cols="3">
          <h4>チェック間隔</h4>
          <div class="d-flex align-center">
            <div style="width: 120px;">
              <v-select
                variant="outlined"
                density="compact"
                hide-details
                class="mr-2"
                :items="intervalOptions"
                item-value="value"
                item-title="label"
                v-model="inteval"
              ></v-select>
            </div>
          </div>
        </v-col>
      </v-row>

      <h4 class="mt-8 mb-4">児童選択</h4>
      <div>
        <v-progress-linear
          v-if="isFetchingChildren"
          indeterminate
          color="primary"
          class="my-8"
        ></v-progress-linear>
      </div>
      <v-row>
        <v-col cols="6">
          <h5>個別に選択</h5>
          <div>
            <v-card
              variant="outlined"
              class="pa-2 mb-2"
              v-for="child in childrenOptions"
              :key="child.classId"
            >
              <div class="d-flex align-center">
                <div> {{ child.lastName }} {{ child.firstName }} </div>
                <v-spacer></v-spacer>
                <div>
                  <v-btn
                    variant="outlined"
                    small
                    color="primary"
                    @click="selectChild(child)"
                  >選択</v-btn>
                </div>
              </div>
            </v-card>
          </div>
        </v-col>
        <v-col cols="6">
          <h5>選択された児童</h5>
          <div>
            <v-card
              variant="outlined"
              class="pa-2 mb-2"
              v-for="child in selectedChildren"
              :key="child.classId"
            >
              <div class="d-flex align-center">
                <div> {{ child.lastName }} {{ child.firstName }} </div>
                <v-spacer></v-spacer>
                <div>
                  <v-btn
                    variant="outlined"
                    small
                    @click="removeChild(child)"
                  >選択解除</v-btn>
                </div>
              </div>
            </v-card>
          </div>
        </v-col>
      </v-row>
    </div>

    <v-divider class="my-8"></v-divider>

    <div>
        <v-progress-linear
          v-if="isCreating"
          indeterminate
          color="primary"
          class="my-8"
        ></v-progress-linear>
      </div>

    <div class="mt-8 d-flex">
      <v-spacer></v-spacer>
      <div class="d-flex flex-column align-center">
        <v-checkbox
          class="mb-2"
          label="パターンとして登録する"
          v-model="willCreateTemplate"
          color="primary"
        ></v-checkbox>
        <div
          v-if="willCreateTemplate"
          class="mb-2"
          style="width: 300px;"
        >
          <v-text-field
            v-model="templateTitle"
            variant="outlined"
            full-width
            label="パターン名"
          ></v-text-field>
        </div>
        <v-btn
          x-large
          variant="flat"
          color="primary"
          :disabled="!isCreateValid || isCreating"
          @click="create"
        >作成</v-btn>
      </div>
      <v-spacer></v-spacer>
    </div>

    <!-- 削除モーダル -->
    <v-dialog
      :model-value="templateToDelete !== null"
      @update:model-value="(val) => { if (!val) templateToDelete = null }"
      max-width="480"
    >
      <v-card v-if="templateToDelete">
        <v-card-title>本当に削除しますか？</v-card-title>
        <v-card-text>
          <div class="mb-4"> テンプレート名: <strong>{{ templateToDelete.templateTitle }}</strong> </div>
          <v-progress-linear
            v-if="isDeletingTemplate"
            indeterminate
            color="red"
            class="my-8"
          ></v-progress-linear>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="grey"
            variant="flat"
            size="large"
            :disabled="isDeletingTemplate"
            @click="() => templateToDelete = null"
          >キャンセル</v-btn>
          <v-btn
            color="red"
            variant="flat"
            size="large"
            :disabled="isDeletingTemplate"
            @click="deleteTemplate"
          >削除</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';

import LocalDataService from '@/service/LocalDataService';
import { classModule } from '@/store/dataModules/classModule';

import { napCreateModule } from '@/store/dataModules/napCreateModule';
import { NurseryChildResponse, NurseryClassResponse, NurseryNapTemplateResponse } from 'chaild-api/lib';

interface DataType {
  isFetchingChildren: boolean;
  isCreating: boolean;

  willCreateTemplate: boolean;
  templateTitle: string;

  isFetchingTemplate: boolean;

  templateToDelete: NurseryNapTemplateResponse | null;
  isDeletingTemplate: boolean;

  isFetchingClasses: boolean;
}

export default defineComponent({

  data: (): DataType => {
    return {
      isFetchingChildren: false,
      isCreating: false,

      willCreateTemplate: false,
      templateTitle: '',
      isFetchingTemplate: false,

      templateToDelete: null,
      isDeletingTemplate: false,
      isFetchingClasses: false
    }
  },

  watch: {
    date: {
      handler() {
        this.listStaffs();
      },
    },
  },

  computed: {
    napTemplates() {
      return napCreateModule.napTemplates;
    },
    staffs() {
      return napCreateModule.staffs;
    },
    classes(): NurseryClassResponse[] {
      return napCreateModule.classes;
    },
    classOptions(): Array<{ title: string; value: string | number }> {
      return this.classes.map((c) => {
        return {
          title: `${c.year}年度 ${c.className}`,
          value: c.classId
        }
      });
    },
    selectedChildren() {
      return napCreateModule.selectedChildren;
    },
    childrenOptions() {
      return napCreateModule.childrenOptions;
    },
    staffOptions() {
      return napCreateModule.staffs.filter(s => !s.isHidden).map((staff) => {
        return {
          userId: staff.userId,
          name: `${staff.lastName} ${staff.firstName}`
        }
      })
    },
    ageOptions() {
      return [
        { age: 0, label: '0歳' },
        { age: 1, label: '1歳' },
        { age: 2, label: '2歳' },
        { age: 3, label: '3歳' },
        { age: 4, label: '4歳' },
        { age: 5, label: '5歳以上' },
      ]
    },
    intervalOptions() {
      return [
        { value: 0, label: '5分' },
        { value: 1, label: '10分' },
        { value: 2, label: '15分' },
        { value: 3, label: '30分' },
        { value: 4, label: '60分' },
      ]
    },
    isCreateValid(): boolean {
      if (this.willCreateTemplate) {
        return (
          this.recorderId !== null &&
          this.selectedChildren.length > 0 &&
          this.templateTitle.trim().length > 0
        );  
      }
      return (
        this.recorderId !== null &&
        this.selectedChildren.length > 0
      );
    },
    date: {
      get() {
        return napCreateModule.date;
      },
      set(value: string) {
        napCreateModule.setDate(value);
        this.fetchClasses()
      }
    },
    inteval: {
      get() {
        return napCreateModule.interval;
      },
      set(value: number) {
        napCreateModule.setInterval(value);
      }
    },
    ages: {
      get() {
        return napCreateModule.ages;
      },
      set(value: number[]) {
        napCreateModule.setAges(value);
      }
    },
    recorderId: {
      get() {
        return napCreateModule.recorderId;
      },
      set(value: number) {
        napCreateModule.setRecorderId(value);
      }
    },
    classIds: {
      get() {
        return napCreateModule.classIds;
      },
      set(value: number[]) {
        const oldValue = [...napCreateModule.classIds];
        napCreateModule.setClassIds(value);

        if (value.length > oldValue.length) {
          const newValues = value.filter((id) => {
            return oldValue.indexOf(id) < 0;
          });

          this.addChildrenWithClassIds(newValues);
        } else {
          const removeValues = oldValue.filter((id) => {
            return value.indexOf(id) < 0;
          });

          this.removeChildrenWithClassId(removeValues);
        }
      }
    }
  },
  
  methods: {
    async listTemplates() {
      this.isFetchingTemplate = true;
      await napCreateModule.listNapTemplates();
      this.isFetchingTemplate = false;
    },
    listStaffs() {
      napCreateModule.listStaffs(this.date);
    },
    selectTemplate(t: NurseryNapTemplateResponse) {
      const recorderId = t.recorderId;
      const classIds = t.class.classes.map((c) => c.classId);
      const ages = t.age.ages;
      // TODO: Age関係?
      
      napCreateModule.setRecorderId(recorderId);
      napCreateModule.setClassIds(classIds);
      napCreateModule.setSelectedChildren([]);
      napCreateModule.setAges(ages);

      this.addChildrenWithClassIds(classIds);

      // napCreateModule.setInterval(t.)
    },
    openDeleteModal(t: NurseryNapTemplateResponse | null) {
      this.templateToDelete = t;
    },
    async deleteTemplate() {
      if (this.templateToDelete) {
        this.isDeletingTemplate = true;
        await napCreateModule.deleteNapTemplate(this.templateToDelete.napTemplateId);
        await napCreateModule.listNapTemplates();
        this.templateToDelete = null;
        this.isDeletingTemplate = false;
      }
    },
    async addChildrenWithClassIds(ids: number[]) {
      this.isFetchingChildren = true;
      await Promise.all(ids.map((id) => napCreateModule.addChildrenWithClassIds(id)));
      this.isFetchingChildren = false;
    },
    async removeChildrenWithClassId(ids: number[]) {
      this.isFetchingChildren = true;
      await Promise.all(ids.map((id) => napCreateModule.removeChildrenWithClassId(id)));
      this.isFetchingChildren = false;
    },
    selectChild(child: NurseryChildResponse) {
      napCreateModule.addSelectedChildren(child);
    },
    removeChild(child: NurseryChildResponse) {
      napCreateModule.removeChild(child.childId);
    },
    async create() {
      if (this.willCreateTemplate) {
        this.isCreating = true;
        await this.createTemplate();
      }
      
      this.isCreating = true;
      const response = await napCreateModule.createNap();
      this.isCreating = false;
      if (response && response.napId) {
        this.$router.push(`/nap/${response.napId}/detail`);
      } else {
        alert('エラー: 午睡チェックの作成に失敗しました');
      }
    },
    async createTemplate() {
      await napCreateModule.createNapTemplate(this.templateTitle);
    },
    async fetchClasses() {
      this.isFetchingClasses = true
      await napCreateModule.listClass()
      this.isFetchingClasses = false
    }
  },

  mounted() {
    this.listTemplates();
    this.listStaffs();
    this.fetchClasses()
  }
});
</script>